'use strict';

var components = require('./components/components');

module.exports = {
	resolve: function(template, config, deps) {
		if (!template) return;
		return template.replace(/{{([\s\S]+?)}}/g, function(s) {
			var componentsData = components.getData(deps);
			var key = s.slice(2, -2);
			var resolver = componentsData[key];
			if (resolver) {
				// The key is a component
				return resolver(config, deps);
			} else if (deps && deps.l10nFn) {
				// The key is property key || not
				return deps.l10nFn(key) || key;
			}
			// Fallback - will return raw value of s
			return s;
		});
	}
};




//////////////////
// WEBPACK FOOTER
// ./~/ad-theme-customizer-client/src/template-resolver.js
// module id = 3
// module chunks = 0